import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Dashboard from './Component/Dashboard';

import Phi from "./../../Phi/Phi";

const mapStateToProps = (state, ownProps) => ({
    
    organizationId: JSON.parse(Phi.Storage.getItem('organization')) ? JSON.parse(Phi.Storage.getItem('organization'))[0].org_id : null,

    currentProgram: state.organization.currentProgram,    
    organization: state.organization.currentOrganization,
    programs: state.organization.programs,
    startNodeMap: state.organization.startNodeMap,
    htmlContent: state.organization.htmlContent,
    overViewReport: state.organization.overViewReport,

    episodeStats: state.student.episodeStats,
    growthOverview: state.organization.growthOverview
});


const mapDispatchToProps = (dispatch) => ({
    getReport: (reportType, config) => dispatch(Actions.getReport(reportType, config)),
    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    setLoader: () => dispatch(Actions.setLoader()),
    unsetLoader: () => dispatch(Actions.unsetLoader()),
    fetchOverViewReport: (startNode) => dispatch(Actions.fetchOverViewReport(startNode)),
    changeReportInReducer: (billingId) => dispatch(Actions.changeReportInReducer(billingId)),

    fetchEpisodeStats: (inOrganizationId, inStatLimit, inClass, inSection) => dispatch(Actions.fetchClinicEpisodeStats(inOrganizationId, inStatLimit, inClass, inSection)),
    fetchLatestGrowthOverview: (inOrganizationId, inClass, inSection) => dispatch(Actions.fetchLatestGrowthOverview(inOrganizationId, inClass, inSection)),

});


export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)


// WEBPACK FOOTER //
// ./src/Containers/DashboardContainer/index.js